// Frame 20 — checkout return: success (33:3431). US-141.
//
// SPEC NOTE, kept here rather than silently "fixed": the Figma frame draws
// this as the landing point of a just-completed hosted checkout — "Billing
// is live and your key is active on docs.acme.com. Your first invoice is in
// your email." plus a masked LICENSE KEY reveal field (Control/CopyField,
// "Masked=True is the resting state everywhere except immediately after
// issue"). The payment provider is excluded from this entire run (PRD 18
// §Build intent), so nothing ever completes a checkout here and no key is
// ever issued by this route — showing that copy or that field would assert
// a purchase and a key this build cannot back. This screen instead reads
// GET /licenses and reports the org's ACTUAL current plan, honestly, with
// no invented invoice/checkout narrative and no key of any kind (masked or
// not).

import { hrefs } from "../../shell/hrefs";
import { Button } from "../../ui/Button";
import { useLicense } from "./api";
import { PLAN_INFO } from "./pricing";
import { CheckoutReturnPanel } from "./CheckoutReturnPanel";
import "./commerce.css";

export function CheckoutSuccessScreen({ orgSlug }: { orgSlug: string }) {
  const license = useLicense();
  const to = hrefs(orgSlug);

  const plan = license.data?.plan ?? null;
  const title = plan ? `You're on ${PLAN_INFO[plan].label}` : "Your plan";

  const body = license.isPending
    ? "Checking your plan…"
    : license.isError || !plan
      ? "We couldn't confirm a plan change from here — Plan & billing always shows your current, up-to-date status."
      : `Your workspace is on ${PLAN_INFO[plan].label}, bound to ${
          license.data?.domains.length
            ? license.data.domains.join(", ")
            : "no domain yet"
        }.`;

  return (
    <CheckoutReturnPanel
      icon="check"
      iconTone="nominal"
      title={title}
      body={body}
      actions={
        <>
          <Button to={to.billing} variant="secondary">
            Plan & billing
          </Button>
          <Button to={to.install} variant="primary">
            Go to install
          </Button>
        </>
      }
    />
  );
}
